



















































































































































import { debounceProcess } from "@/helpers/debounce";
import { ResponsePagination } from "@/models/constant/interface/common.interface";
import { Messages } from "@/models/enums/messages.enum";
import { ContactData } from "@/models/interface/contact.interface";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { DataWarehouseBranch } from "@/models/interface/logistic.interface";
import { contactServices } from "@/services/contact.service";
import { logisticServices } from "@/services/logistic.service";
import moment, { Moment } from "moment";
import { Component, Vue } from "vue-property-decorator";
import { salesOrderServices } from "@/services/salesorder.service";
import { DataResponseListInternalContractChangeLocation } from "@/models/interface/salesOrder.interface";
import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";

interface LoadingComponent {
  loadingFind: boolean;
  loadingBastNumber: boolean;
  download: boolean;
  print: boolean;
  loadingCustomerName: boolean;
  loadingInternalContract: boolean;
  loadingBranch: boolean;
}

@Component
export default class PindahLokasi extends Vue {
  DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
  form = this.$form.createForm(this, { name: "PindahLokasi" });
  page = 1;
  limit = 10;
  params: RequestQueryParamsModel = {};
  totalData = 0;
  filterForm = {
    date: null as Moment[] | null,
  };
  loading: LoadingComponent = {
    loadingFind: false,
    loadingBastNumber: false,
    download: false,
    print: false,
    loadingCustomerName: false,
    loadingInternalContract: false,
    loadingBranch: false,
  };
  columnsTable = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      width: 110,
      scopedSlots: { customRender: "no" },
    },
    {
      title: "Branch",
      dataIndex: "branchName",
      key: "branchName",
      width: 150,
      scopedSlots: { customRender: "isNull" },
    },
    {
      title: "Internal Contract Number",
      dataIndex: "icNumber",
      key: "icNumber",
      width: 200,
      scopedSlots: { customRender: "isNull" },
    },
    {
      title: this.$t("lbl_customer_name"),
      dataIndex: "customerName",
      key: "customerName",
      width: 170,
      scopedSlots: { customRender: "isNull" },
    },
    {
      title: "BAPL Number",
      dataIndex: "baplNumber",
      key: "baplNumber",
      width: 150,
      scopedSlots: { customRender: "isNull" },
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      width: 150,
      scopedSlots: { customRender: "isNull" },
    },
    {
      title: "Rent Period",
      dataIndex: "rentPeriod",
      key: "rentPeriod",
      width: 150,
      scopedSlots: { customRender: "isNull" },
    },
    {
      title: "QTY",
      dataIndex: "qty",
      key: "qty",
      width: 150,
      scopedSlots: { customRender: "isNull" },
    },
    {
      title: this.$root.$t("lbl_action").toString(),
      dataIndex: "operation",
      key: "operation",
      scopedSlots: { customRender: "operation" },
      button: ["view"],
      width: 120,
      align: "center",
    },
  ];
  formRules = {
    branch: {
      label: "Branch",
      name: "branch",
      placeholder: "Insert Branch",
      decorator: [
        "branch",
        {
          rules: [
            {
              required: false,
              message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
            },
          ],
        },
      ],
    },
    customerName: {
      label: "lbl_customer_name",
      name: "customerName",
      placeholder: "lbl_customer_name_placeholder",
      decorator: [
        "customerName",
        {
          rules: [
            {
              required: false,
              message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
            },
          ],
        },
      ],
    },
    internalContractNo: {
      label: "Internal Contract Number",
      name: "internalContractNo",
      placeholder: "Insert Internal Contract Number",
      decorator: [
        "internalContractNo",
        {
          rules: [
            {
              required: false,
              message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
            },
          ],
        },
      ],
    },
    createdDate: {
      label: "Created Date",
      name: "createdDate",
      placeholder: "Insert Created Date",
      decorator: [
        "createdDate",
        {
          rules: [
            {
              required: false,
              message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
            },
          ],
        },
      ],
    },
  };
  dataSource: DataResponseListInternalContractChangeLocation[] = [];
  dataCustomerName: ContactData[] = [];
  dataInternalContract: DataResponseListInternalContractChangeLocation[] = [];
  dataBranch: DataWarehouseBranch[] = [];
  internalContractNo = "";
  idCustomer = "";
  idBranch = "";

  handleChangeBranch(value) {
    this.idBranch = value;
    this.form.resetFields(["internalContractNo", "bastNumber"]);
    this.getInternalContract("");
  }
  handleChangeCustomer(value) {
    this.idCustomer = value;
    this.form.resetFields(["internalContractNo", "bastNumber"]);
    this.getInternalContract("");
  }
  handleChangeIC(value) {
    this.internalContractNo = value;
  }
  getBranch(valueSearch) {
    const params: RequestQueryParamsModel = {
      page: 0,
      limit: 10,
    };
    if (valueSearch)
      params.search = `name~*${valueSearch}*_OR_code~*${valueSearch}*_OR_address~*${valueSearch}`;
    this.loading.loadingBranch = true;
    logisticServices
      .listWarehouseBranch(params, "")
      .then((response) => {
        this.dataBranch = response.data;
      })
      .finally(() => (this.loading.loadingBranch = false));
  }
  getInternalContract(valueSearch) {
    const params: RequestQueryParamsModel = {
      limit: 10,
      page: 0,
    };
    if (valueSearch)
      params.search = `internalContract.documentNo~*${valueSearch}*`;
    if (this.idBranch) {
      if (params.search)
        params.search += `_AND_internalContract.branch.secureId~${this.idBranch}`;
      else params.search = `internalContract.branch.secureId~${this.idBranch}`;
    }
    if (this.idCustomer) {
      if (params.search)
        params.search += `_AND_internalContract.customer.secureId~${this.idCustomer}`;
      else
        params.search = `internalContract.customer.secureId~${this.idCustomer}`;
    }
    this.loading.loadingInternalContract = true;
    salesOrderServices
      .getListInternalContractChangeLocation(params)
      .then((response) => (this.dataInternalContract = response.data))
      .finally(() => (this.loading.loadingInternalContract = false));
  }
  responseViewTable(response) {
    this.$router.push(`/sales/pindah-lokasi/cetak/${response.data.id}`);
  }
  getCustomerName(valueSearch) {
    const params: RequestQueryParamsModel = {
      limit: 10,
      page: 0,
      search: "customer~true_AND_active~true",
    };
    if (valueSearch)
      params.search += `_AND_firstName~*${valueSearch}*_OR_lastName~*${valueSearch}*`;
    this.loading.loadingCustomerName = true;
    contactServices
      .listContactData(params)
      .then((response) => (this.dataCustomerName = response.data))
      .finally(() => (this.loading.loadingCustomerName = false));
  }
  responsePageSizeChange(response: ResponsePagination): void {
    this.limit = response.size;
    this.page = 1;
    this.onSubmit();
  }
  responseCurrentPageChange(response: ResponsePagination): void {
    this.page = response.page;
    this.onSubmit();
  }
  checkValue(value): string {
    if (value && !value.includes("undefined")) {
      return value;
    } else {
      return ",ALL";
    }
  }
  checkParams(res): string {
    let params = "";
    // company is mandatory
    params += this.$store.state.authStore.authData.companyName;
    params += this.checkValue(`,${res["customerMaintenanceNumber"]}`);
    params += this.checkValue(`,${res["workOrderNumber"]}`);
    params += this.checkValue(`,${res["csfNumber"]}`);
    params += this.checkValue(`,${res["customerName"]}`);
    params += this.checkValue(`,${res["unitCode"]}`);
    params += this.checkValue(
      res["dateFrom"]
        ? `,${moment(res["dateFrom"]).format("DD-MMM-yyyy")}`
        : null
    );
    params += this.checkValue(
      res["dateTo"] ? `,${moment(res["dateTo"]).format("DD-MMM-yyyy")}` : null
    );

    return params;
  }
  assignSearch(key, value, and): string {
    if (key === "branch" && value)
      return (
        and + `internalContractDetail.internalContract.branch.secureId~${value}`
      );
    else if (key === "customerName" && value)
      return (
        and +
        `internalContractDetail.internalContract.customer.secureId~${value}`
      );
    else if (key === "internalContractNo" && value)
      return (
        and + `internalContractDetail.internalContract.documentNo~*${value}*`
      );
    else return "";
  }
  dynamicSearch(res): string {
    let search = "";
    if (this.filterForm.date && this.filterForm.date.length > 0) {
      search = `createdDate>=${moment(this.filterForm.date[0])
        .set({ hour: 0, minute: 0, second: 0 })
        .utcOffset("+07")
        .format()}_AND_createdDate<=${moment(this.filterForm.date[1])
        .set({ hour: 23, minute: 59, second: 59 })
        .utcOffset("+07")
        .format()}`;
    }
    Object.keys(res).forEach((key) => {
      if (!search) {
        search = this.assignSearch(key, res[key], "");
      } else {
        search += this.assignSearch(key, res[key], "_AND_");
      }
    });
    return search;
  }
  onSubmit(): void {
    this.form.validateFields((err, values) => {
      if (err) return;
      const params: RequestQueryParamsModel = {
        page: this.page - 1,
        limit: this.limit,
      };
      params.search = this.dynamicSearch(values);
      this.loading.loadingFind = true;
      salesOrderServices
        .getListInternalContractChangeLocation(params)
        .then((response) => {
          this.totalData = response.totalElements;
          this.dataSource = response.data.map((dataMap, key) => {
            return {
              ...dataMap,
              key,
              no: key + 1,
              createdDate: moment(dataMap.createdDate).format(
                this.DEFAULT_DATE_FORMAT
              ),
            };
          });
        })
        .finally(() => (this.loading.loadingFind = false));
    });
  }
  filterOption(input, option) {
    return (
      option.componentOptions.children[0].componentOptions.children[1].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }

  created() {
    this.getCustomerName = debounceProcess(this.getCustomerName, 200);
    this.getInternalContract = debounceProcess(this.getInternalContract, 400);
    this.getBranch = debounceProcess(this.getBranch, 400);

    this.getCustomerName("");
    this.getBranch("");
    this.getInternalContract("");
  }

  get formItemLayout() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
    };
  }
}
